import { defaultDateLib } from "../classes/DateLib.js";
/**
 * Formats the week number.
 *
 * @defaultValue The week number as a string, with a leading zero for single-digit numbers.
 * @param weekNumber The week number to format.
 * @param dateLib The date library to use for formatting. Defaults to
 *   `defaultDateLib`.
 * @returns The formatted week number as a string.
 * @group Formatters
 * @see https://daypicker.dev/docs/translation#custom-formatters
 */
export function formatWeekNumber(weekNumber) {
  let dateLib = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDateLib;
  if (weekNumber < 10) {
    return dateLib.formatNumber("0".concat(weekNumber.toLocaleString()));
  }
  return dateLib.formatNumber("".concat(weekNumber.toLocaleString()));
}